export default __webpack_public_path__ + "static/2115-3d95dd48daf862be544be3b8c59087fa.gif";